import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-imagebox-bullet-scroll',
  imports: [CommonModule],
  templateUrl: './imagebox-bullet-scroll.component.html',
  styleUrl: './imagebox-bullet-scroll.component.scss'
})
export class ImageboxBulletScrollComponent {

  @ViewChild('scrollSection') scrollSection!: ElementRef<HTMLElement>;
  
  // Tracks overall scroll progress from 0 to 5
  scrollProgress = 0; 
  @Input() imgLink = '';

  @Input() steps = [
    {
      id: '01',
      title: '01. Choose Your Membership',
      description: 'Pick a Membership to receive discounts with unlimited use.'
    },
    {
      id: '02',
      title: '02. Complete Your Profile',
      description: 'Make sure to complete your profile after payment to activate the plan.'
    },
    {
      id: '03',
      title: '03. Connect With a Provider',
      description: 'Choose the best suitable provider from our wide range of network'
    },
    {
      id: '04',
      title: '04. Pay the Discounted Rate',
      description: 'Pay a discounted fee directly at the time of appointment'
    },
    {
      id: '05',
      title: '05. Get Care Without Post-billing',
      description: 'Get the care you need and focus on healing, not worrying about bills in the mail.'
    }
  ];

  constructor(private cdr: ChangeDetectorRef) {}

  // Standard scroll listener
  @HostListener('window:scroll', [])
  onScroll() {
    this.calculateProgress();
  }

  // Mobile touch listener for real-time updates on iOS/Android
  @HostListener('window:touchmove', [])
  onTouchMove() {
    this.calculateProgress();
  }

  private calculateProgress() {
    if (!this.scrollSection) return;

    const section = this.scrollSection.nativeElement;
    const rect = section.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Total height of the 300vh container minus one screen view
    const scrollableDistance = section.offsetHeight - windowHeight;

    // Distance from the top of the section to the top of the viewport
    const scrolled = -rect.top;

    if (scrolled < 0) {
      this.scrollProgress = 0;
    } else if (scrolled > scrollableDistance) {
      this.scrollProgress = this.steps.length;
    } else {
      // Calculate 0 to 5 based on scroll depth
      this.scrollProgress = (scrolled / scrollableDistance) * this.steps.length;
    }

    // Explicitly trigger change detection for mobile performance
    this.cdr.detectChanges();
  }

  getFillPercentage(index: number): number {
    const progressForThisStep = this.scrollProgress - index;
    if (progressForThisStep <= 0) return 0;
    if (progressForThisStep >= 1) return 100;
    return progressForThisStep * 100;
  }
}
